










import Vue from 'vue';
export default Vue.extend({
  name: 'AppNav',
  data() {
    return {
      routes: [
        {
          text: 'Select',
          name: 'Select',
          key: 'select',
        },
        {
          text: 'Input',
          name: 'Input',
          key: 'input',
        },
        {
          text: 'Textarea',
          name: 'Textarea',
          key: 'textarea',
        },
        {
          text: 'Checkbox',
          name: 'Checkbox',
          key: 'checkbox',
        },
        {
          text: 'Radio',
          name: 'Radio',
          key: 'radio',
        },
        {
          text: 'Button',
          name: 'Button',
          key: 'button',
        },
        {
          text: 'Crate',
          name: 'Crate',
          key: 'crate',
        },
        {
          text: 'Datalist',
          name: 'Datalist',
          key: 'datalist',
        },
        {
          text: 'Element',
          name: 'Element',
          key: 'element',
        },
        {
          text: 'Fieldset',
          name: 'Fieldset',
          key: 'fieldset',
        },
        {
          text: 'Label',
          name: 'Label',
          key: 'label',
        },
        {
          text: 'Legend',
          name: 'Legend',
          key: 'legend',
        },
        {
          text: 'Datepicker',
          name: 'Datepicker',
          key: 'datepicker',
        },

        {
          text: 'Examples',
          name: 'Examples',
          path: '/examples',
        },
      ],
    };
  },
});
